<div class="wrapper" [class.sidebar-collapsed]="sidebarCollapsed">
    <div class="sidebar-backdrop" *ngIf="!sidebarCollapsed" (click)="toggleSidebar()"></div>
    <div class="sidebar" data-color="blue">
        <app-sidebar></app-sidebar>
    </div>
    <div class="main-panel">
        <app-navbar (sidebarToggleClick)="toggleSidebar()"></app-navbar>
        <app-alert></app-alert>
        <app-tab-bar></app-tab-bar>
        <div class="router-content-wrapper">
            <!-- <div id="divider_id" class="website-divider-container-287611">
                <svg xmlns="http://www.w3.org/2000/svg" class="divider-img-287611" viewBox="0 0 1080 137"
                    preserveAspectRatio="none">
                    <path
                        d="M 0,137 V 59.03716 c 158.97703,52.21241 257.17659,0.48065 375.35967,2.17167 118.18308,1.69101 168.54911,29.1665 243.12679,30.10771 C 693.06415,92.25775 855.93515,29.278599 1080,73.61449 V 137 Z"
                        style="opacity:0.85; fill: #FFD700;"></path>

                    <path
                        d="M 0,10.174557 C 83.419822,8.405668 117.65911,41.78116 204.11379,44.65308 290.56846,47.52499 396.02558,-7.4328 620.04248,94.40134 782.19141,29.627636 825.67279,15.823104 1080,98.55518 V 137 H 0 Z"
                        style="opacity:0.5; fill: #FFD700;"></path>

                    <path
                        d="M 0,45.10182 C 216.27861,-66.146913 327.90348,63.09813 416.42665,63.52904 504.94982,63.95995 530.42054,22.125806 615.37532,25.210412 700.33012,28.295019 790.77619,132.60682 1080,31.125744 V 137 H 0 Z"
                        style="opacity:0.25; fill: #FFD700;"></path>
                </svg>
            </div> -->
            <ng-container *ngIf="(tabService.tabs$ | async)?.length > 0; else noTabsState">
                <router-outlet></router-outlet>
            </ng-container>
            <ng-template #noTabsState>
                <div class="no-tabs-state">
                    <mat-icon class="no-tabs-icon">tab</mat-icon>
                    <h4 class="no-tabs-title">No open tabs</h4>
                    <p class="no-tabs-sub">Select an item from the sidebar to get started.</p>
                </div>
            </ng-template>
            <!-- <button mat-fab class="floating-glass">
                <mat-icon class="icon">smart_toy</mat-icon>
                <span class="label">Chat with MIA</span>
            </button> -->
        </div>
        <app-footer></app-footer>
    </div>
    <div class="plan-expired-overlay"
        *ngIf="!accountInfo.isSuperUser && !accountInfo.supervisorMode && isOverdue(initialData?.current_bill?.datepromised)">
        <p class="text-center fw-semibold">
            <strong>⚠️ You have an overdue bill.</strong> Please settle your payment to continue using the system
            without
            interruption.
        </p>
        <div class="text-center mt-3">
            <button class="btn btn-danger px-4" (click)="logout()">Logout</button>
        </div>
    </div>
    <div class="modal-loading bg-default" *ngIf="isSessionExpired">
        <div class="spinner-container">
            <h5>Session expired please login again.</h5>
            <button mat-button class="logout-button" *ngIf="!logLoading; else logoutTemplate"
                (click)="logout()">Logout</button>
            <ng-template #logoutTemplate>
                <button mat-button class="logout-button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </div>

    <!-- Broadcast Message Popup -->
    <div class="broadcast-popup-container"
        *ngIf="!accountInfo?.isSuperUser && (broadcastMessages && broadcastMessages.length > 0)">
        <div class="broadcast-popup" [class.minimized]="isBroadcastMinimized" [class.show]="showBroadcastPopup">

            <!-- Header -->
            <div class="broadcast-popup-header" (click)="toggleBroadcastPopup()">
                <div class="header-content">
                    <mat-icon class="broadcast-icon">campaign</mat-icon>
                    <span class="header-title">Broadcast Messages</span>
                    <span class="message-count" *ngIf="broadcastMessages.length > 1">
                        ({{currentMessageIndex + 1}}/{{broadcastMessages.length}})
                    </span>
                </div>
                <div class="header-actions">
                    <button mat-icon-button class="minimize-btn"
                        (click)="toggleBroadcastPopup(); $event.stopPropagation()">
                        <mat-icon>{{ isBroadcastMinimized ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                    <button mat-icon-button class="close-btn" (click)="closeBroadcastPopup(); $event.stopPropagation()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Body -->
            <div class="broadcast-popup-body" *ngIf="!isBroadcastMinimized">
                <div class="message-content">
                    <div class="message-meta">
                        <span class="message-type">
                            <mat-icon class="meta-icon">{{
                                getTargetIcon(broadcastMessages[currentMessageIndex].targetType) }}</mat-icon>
                            From:
                            <strong>{{ broadcastMessages[currentMessageIndex].messageFrom }}</strong>
                        </span>
                        <span class="message-date">
                            {{ broadcastMessages[currentMessageIndex].createdDate | date:'MMM d, y' }}
                        </span>
                    </div>
                    <div class="message-text">
                        {{ broadcastMessages[currentMessageIndex].message }}
                    </div>

                    <!-- Confirmation Button -->
                    <div class="message-actions">
                        <button mat-raised-button color="primary" *ngIf="!isLoading; else loadingTemplate"
                            class="confirm-btn" [disabled]="broadcastMessages[currentMessageIndex].confirmed"
                            (click)="confirmMessage(currentMessageIndex)">
                            <mat-icon>{{ broadcastMessages[currentMessageIndex].confirmed ? 'check_circle' : 'check'
                                }}</mat-icon>
                            <span>{{ broadcastMessages[currentMessageIndex].confirmed ? 'Confirmed' : 'Confirm'
                                }}</span>
                        </button>
                        <ng-template #loadingTemplate>
                            <button mat-raised-button color="primary" cdkFocusInitial disabled>
                                <mat-icon>{{ broadcastMessages[currentMessageIndex].confirmed ? 'check_circle' : 'check'
                                    }}</mat-icon>
                                <span>{{ broadcastMessages[currentMessageIndex].confirmed ? 'Confirmed' : 'Confirm'
                                    }}</span>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </ng-template>
                    </div>
                </div>

                <!-- Navigation for multiple messages -->
                <div class="message-navigation" *ngIf="broadcastMessages.length > 1">
                    <button mat-icon-button [disabled]="currentMessageIndex === 0" (click)="previousMessage()">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <div class="navigation-dots">
                        <span *ngFor="let msg of broadcastMessages; let i = index" class="dot"
                            [class.active]="i === currentMessageIndex" [class.confirmed]="msg.confirmed"
                            (click)="goToMessage(i)">
                        </span>
                    </div>
                    <button mat-icon-button [disabled]="currentMessageIndex === broadcastMessages.length - 1"
                        (click)="nextMessage()">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>